<h1 mat-dialog-title>Finaliser la playlist</h1>
<div mat-dialog-content>
  <p style="color: #3d465a; margin-bottom: 20px;">
    Cette action va convertir les votes en positions ordonnées et activer le mode édition.
    Seuls les membres du comité peuvent effectuer cette action.
  </p>

  <mat-form-field appearance="fill" style="width: 100%;">
    <mat-label>Mot de passe du comité</mat-label>
    <input
      matInput
      [type]="hidePassword ? 'password' : 'text'"
      [formControl]="passwordControl"
      placeholder="Entrez le mot de passe"
      (keydown.enter)="$event.preventDefault(); onConfirm()">
    <button
      mat-icon-button
      matSuffix
      (click)="hidePassword = !hidePassword"
      type="button">
      <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
    <mat-error *ngIf="passwordControl.hasError('required')">
      Le mot de passe est requis
    </mat-error>
  </mat-form-field>

  <p *ngIf="errorMessage" style="color: #d32f2f; font-size: 12px; margin-top: 8px;">
    {{ errorMessage }}
  </p>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Annuler</button>
  <button
    mat-flat-button
    color="primary"
    (click)="onConfirm()"
    [disabled]="!passwordControl.valid">
    Confirmer
  </button>
</div>

